import { render, staticRenderFns } from "./search-places.vue?vue&type=template&id=07cf5a8a&scoped=true"
import script from "./search-places.vue?vue&type=script&lang=js"
export * from "./search-places.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cf5a8a",
  null
  
)

export default component.exports